import {
  AppRoutes,
  COPY_TOKEN,
  CopyProvider,
  DEEP_LINK_TOKEN,
  DeepLinkProvider,
  GameDetailsModel,
  GamesRoutes,
  MODAL_TOKEN,
  ModalProvider
} from '@core';
import { inject } from '@angular/core';
import { Share } from '@capacitor/share';
import { Observable, switchMap } from 'rxjs';
import { formatGamePost } from './social-content';

const buildGamePost = (game: GameDetailsModel, url: string): string => {
  const endDate: string = new Date(new Date(game.gameDateStart).getTime() + (game.duration ?? 0) * 60000).toISOString();

  return formatGamePost({
    name: game.gameName,
    startDate: game.gameDateStart,
    endDate,
    locationName: game.location?.name,
    occupiedSlots: game.occupiedSlots,
    totalSlots: game.totalSlots,
    level: game.level,
    priceAmount: game.priceAmount,
    description: game.description,
    url
  });
};

export class ShareGameViewService {
  private readonly modalProvider: ModalProvider = inject(MODAL_TOKEN);
  private readonly deepLinkProvider: DeepLinkProvider = inject(DEEP_LINK_TOKEN);
  private readonly copyProvider: CopyProvider = inject(COPY_TOKEN);

  copyGameLink(gameId: string): void {
    const gameUrl: string = this.generateGameUrl(gameId);
    const gameText: string = 'Dołącz do gierki w aplikacji Orlikfy!';

    this.copyProvider
      .copyToClipboard(`${gameText} ${gameUrl}`)
      .pipe(switchMap(() => this.modalProvider.dismissModal$()))
      .subscribe();
  }

  advancedShareNative(game: GameDetailsModel): void {
    const gameUrl: string = this.generateGameUrl(game.gameId);

    Share.share({
      text: buildGamePost(game, gameUrl),
      url: gameUrl
    });

    this.modalProvider.dismissModal$().subscribe();
  }

  copySocialContent(game: GameDetailsModel): Observable<void> {
    const gameUrl: string = this.generateGameUrl(game?.gameId);

    return this.copyProvider
      .copyToClipboard(buildGamePost(game, gameUrl))
      .pipe(switchMap(() => this.modalProvider.dismissModal$()));
  }

  private generateGameUrl(gameId: string): string {
    const path: string = `${AppRoutes.GAMES}/${GamesRoutes.SHARED}/${gameId}`;

    return this.deepLinkProvider.generateWebLink(path);
  }
}
